import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAtom,
  faFile,
  faFileLines,
  faFolder,
  faHeadSide,
  faStamp,
  faWandMagicSparkles,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";

// export const CHAT_ICON = faComment;
export const DOCUMENT_ICON = faFile;
export const STRUCTURED_DOCUMENT_ICON = faFileLines;
export const RESEARCH_ICON = faAtom;
export const EXPERT_ICON = faHeadSide;
export const FOLDER_ICON = faFolder;
// const SCRIPT_ICON = faFileLines;
export const SKILL_ICON = faWandMagicSparkles;
export const TEMPLATE_ICON = faStamp;

export const ExpertIcon = () => {
  return <FontAwesomeIcon icon={EXPERT_ICON} />;
};

export const TemplateIcon = () => {
  return <FontAwesomeIcon icon={TEMPLATE_ICON} />;
};

export const DocumentIcon = () => {
  return <FontAwesomeIcon icon={DOCUMENT_ICON} />;
};

export const StructuredDocumentIcon = () => {
  return <FontAwesomeIcon icon={STRUCTURED_DOCUMENT_ICON} />;
};

export const SkillIcon = () => {
  return <FontAwesomeIcon icon={SKILL_ICON} />;
};

export const FolderIcon = () => {
  return <FontAwesomeIcon icon={FOLDER_ICON} />;
};

export const ResearchIcon = ({ className }: { className?: string }) => {
  return <FontAwesomeIcon icon={RESEARCH_ICON} className={className} />;
};
